import React from 'react';
import Button, {ButtonProps} from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import {ChainLinkIcon} from '@components/icon/ChainLinkIcon';

interface ChainLinkButtonProps extends ButtonProps {
  kpisCount?: number;
}

export const ChainLinkButton: React.FC<ChainLinkButtonProps> = ({kpisCount, ...props}) => {
  return (
    <Tooltip
      title={
        props.disabled
          ? 'Please select at least 2 KPIs to create a Goal'
          : `Merge ${kpisCount} KPIs and create a Goal`
      }>
      <div className="chain-link-button">
        <Button {...props} variant="contained" color="primary">
          <ChainLinkIcon fill="white" />
        </Button>
      </div>
    </Tooltip>
  );
};
